<template>
  <div>
    <form
      novalidate
      class="md-layout"
      @submit.prevent="validateUser"
    >
      <md-card class="md-layout-item">
        <md-card-content>
          <div class="md-layout md-gutter">

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('email')">
                <label for="email">Email</label>
                <md-input
                  type="email"
                  name="email"
                  id="email"
                  autocomplete="email"
                  v-model="form.email"
                  :disabled="sending"
                />
                <span
                  class="md-error"
                  v-if="!$v.form.email.required"
                >The email is required</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.email.email"
                >Invalid email</span>
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('access')">
                <label for="access">Role</label>
                <md-select
                  name="access"
                  id="access"
                  v-model="form.access"
                  md-dense
                  :disabled="sending"
                >
                  <md-option></md-option>
                  <md-option
                    v-for="rec in Object.keys(ACCESS)"
                    :value="ACCESS[rec]"
                    :key="rec"
                  >{{ rec }}</md-option>
                </md-select>
                <span class="md-error">The role is required</span>
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('password')">
                <label for="password">Password</label>
                <md-input
                  type="password"
                  name="password"
                  id="password"
                  v-model="form.password"
                  :disabled="sending"
                />
                <span
                  class="md-error"
                  v-if="!$v.form.password.required"
                >The password is required</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.password.minlength"
                >Invalid password (mininum length: 8)</span>
              </md-field>
            </div>

          </div>

        </md-card-content>

        <md-progress-bar
          md-mode="indeterminate"
          v-if="sending"/>

        <md-card-actions>
          <md-button
            type="submit"
            class="md-primary md-raised"
            :disabled="sending">
              Create user
          </md-button>
        </md-card-actions>
      </md-card>

      {{ form.access }}

      <md-snackbar :md-active.sync="resultMsg">
        {{ resultMsg }}
      </md-snackbar>
    </form>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate';
import applyConverters from 'axios-case-converter';
import {
  required,
  email,
  minLength,
} from 'vuelidate/lib/validators';

const ACCESS = {
  guest: 0,
  user: 1,
  admin: 2,
};

const ACCESS_VALUES = Object.keys(ACCESS).map(key => ACCESS[key]);
const isValidRole = value => ACCESS_VALUES.includes(value);

export default {
  name: 'NewUser',
  mixins: [validationMixin],
  props: {
    value: null,
  },
  data: () => ({
    form: {
      access: null,
      email: null,
      password: null,
    },
    sending: false,
    lastUser: null,
    resultMsg: null,

    ACCESS,
  }),
  validations: {
    form: {
      access: {
        isValidRole,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
      },

    },
  },
  methods: {
    getValidationClass(fieldName) {
      let result = '';
      const field = this.$v.form[fieldName];

      if (field) {
        result = {
          'md-invalid': field.$invalid && field.$dirty,
        };
      }
      return result;
    },
    clearForm() {
      this.$v.$reset();
      this.form.access = null;
      this.form.email = null;
      this.form.password = null;
    },
    saveUser() {
      this.sending = true;

      // Instead of this timeout, here you can call your API
      const payload = Object.assign({}, this.form);
      const client = applyConverters(this.$http);
      client.post(
        `${process.env.VUE_APP_BACKEND_URL}auth/register/`,
        payload,
      ).then((response) => {
        this.$emit('input', response.data);
        this.lastUser = `${this.form.email}`;
        this.sending = false;
        this.clearForm();
        this.resultMsg = `The user ${this.lastUser} was created with success!`;
      }).catch((error) => {
        // handle error
        console.error(error);
        this.resultMsg = 'Error creating new user';
      }).finally(() => {
        this.sending = false;
      });
    },

    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
</style>
